<script setup lang="ts"></script>
<template>
  <Transition
    enter-from-class="tw:opacity-0"
    enter-active-class="tw:transition-opacity tw:duration-500 tw:delay-200"
    enter-to-class="tw:opacity-100"
    leave-from-class="tw:opacity-100"
    leave-active-class="tw:transition-opacity tw:duration-300"
    leave-to-class="tw:opacity-0"
  >
    <slot />
  </Transition>
</template>
